import { CONFIG } from '../../core/config';
import { CommercialImpacts } from '../commercial-impacts/commercial-impacts';
import { ModelStatus } from '../model-status';
import { ViewModel } from '../view-model';
import { ActivityStep } from './activity-step';
import { DisciplineRequirement } from './discipline-requirement';
import { PlannedMaintenanceMaintenanceStrategy } from './planned-maintenance-maintenance-strategy';
import { PlannedMaintenanceStandards } from './planned-maintenance-standards';

export class PlannedMaintenanceLibraryItem implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Planned Maintenance Library Item';
  readonly apiRoute: string = CONFIG.apiRoutes.plannedMaintenanceLibrary;

  id: string;
  reference: string;
  title: string;
  maintenanceType: MaintenanceType;
  conditionForWork: ConditionForWork;
  activityHours: number;

  frequency: Frequency = Frequency.Calendar;
  calendarValue: number;
  hoursRunValue: number;
  usageFactor: number;

  frequencyCalendarUnit: FrequencyCalendarUnit;
  standards: PlannedMaintenanceStandards[] = [];
  maintenanceStrategies: PlannedMaintenanceMaintenanceStrategy[] = [];
  disciplineRequirements: DisciplineRequirement[] = [];
  activitySteps: ActivityStep[] = [];
  commercialImpacts: CommercialImpacts = new CommercialImpacts();
  rowNumber?: number;

  status: ModelStatus = ModelStatus.Draft;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.reference = data.reference;
    this.title = data.title;
    this.maintenanceType = data.maintenanceType;
    this.conditionForWork = data.conditionForWork;
    this.activityHours = data.activityHours;

    this.frequency = data.frequency;
    this.calendarValue = data.calendarValue;
    this.hoursRunValue = data.hoursRunValue;
    this.usageFactor = data.usageFactor;
    this.frequencyCalendarUnit = data.frequencyCalendarUnit;
    this.rowNumber = data.rowNumber;

    this.status = data.status;

    if (data.standards) {
      this.standards = data.standards.map((standard: PlannedMaintenanceStandards) => {
        const newStandard = new PlannedMaintenanceStandards();
        newStandard.loadFromJson(standard);
        return newStandard;
      });
    }

    if (data.maintenanceStrategies) {
      this.maintenanceStrategies = data.maintenanceStrategies.map((strategy: PlannedMaintenanceMaintenanceStrategy) => {
        const newStrategy = new PlannedMaintenanceMaintenanceStrategy();
        newStrategy.loadFromJson(strategy);
        return newStrategy;
      });
    }

    if (data.disciplineRequirements) {
      this.disciplineRequirements = data.disciplineRequirements.map((discipline: DisciplineRequirement) => {
        const newDiscipline = new DisciplineRequirement();
        newDiscipline.loadFromJson(discipline);
        return newDiscipline;
      });
    }

    if (data.activitySteps) {
      this.activitySteps = data.activitySteps.map((activity: ActivityStep) => {
        const newActivity = new ActivityStep();
        newActivity.loadFromJson(activity);
        return newActivity;
      });

      this.activitySteps.sort((a, b) => a.step - b.step);
    }

    if (data.commercialImpacts) {
      this.commercialImpacts.loadFromJson(data.commercialImpacts);
    }
  }
}

export enum MaintenanceType {
  OnCondition = 0,
  ScheduledDiscardRestoration = 1,
  FailureFinding = 2,
}

export enum ConditionForWork {
  Online = 0,
  EquipmentShutdown = 1,
  PackageShutdown = 2,
  SystemShutdown = 3,
  AssetShutdown = 4,
}

export enum Frequency {
  Calendar = 0,
  HoursRun = 1,
}

export enum FrequencyCalendarUnit {
  Days = 0,
  Weeks = 1,
  Months = 2,
  Years = 3,
  Hours = 4,
}
